import React, { useCallback, useRef } from "react";
import { ChevronRight, House } from "lucide-react";

const PolicyLayout = ({ activeLabel, className = "", intro, sections, title }) => {
  const sectionRefs = useRef({});

  const scrollToSection = useCallback((id) => {
    const element = sectionRefs.current[id];
    if (element) {
      const navbarOffset = 120;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: elementPosition - navbarOffset,
        behavior: "smooth",
      });
    }
  }, []);

  return (
    <div className={`terms-condition-page-container policy-page ${className}`}>
      <div className="terms-condition-page-header-banner">
        <h1 className="terms-condition-page-title">{title}</h1>
        <div className="terms-condition-page-breadcrumb">
          <House className="terms-condition-page-home-icon" />
          <span className="terms-condition-page-breadcrumb-item">Home</span>
          <span className="terms-condition-page-breadcrumb-separator">
            <ChevronRight className="terms-condition-page-home-arrowicon" />
          </span>
          <span className="terms-condition-page-breadcrumb-item terms-condition-page-breadcrumb-active">
            {activeLabel || title}
          </span>
        </div>
      </div>

      <main className="terms-condition-page-main-layout">
        <nav className="terms-condition-page-sidebar">
          <ul className="terms-condition-page-nav-list">
            {sections.map((section) => (
              <li
                key={section.id}
                className="terms-condition-page-nav-item"
                onClick={() => scrollToSection(section.id)}
              >
                {section.title}
              </li>
            ))}
          </ul>
        </nav>

        <div className="terms-condition-page-content-wrapper">
          {intro ? (
            <section className="terms-condition-page-content-section policy-page-intro">
              <h2 className="terms-condition-page-section-heading">{intro.title}</h2>
              <p className="terms-condition-page-section-text">{intro.content}</p>
            </section>
          ) : null}

          {sections.map((section) => (
            <section
              key={section.id}
              id={section.id}
              ref={(el) => (sectionRefs.current[section.id] = el)}
              className="terms-condition-page-content-section"
            >
              <h2 className="terms-condition-page-section-heading">{section.title}</h2>
              <p className="terms-condition-page-section-text">{section.content}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
};

export default PolicyLayout;
